import type { TreeNode } from "../components/TreeView";

/**
 * Scope the views tree to a single turbine for the -live tab.
 *
 * The webserver's tree lists every turbine (it's the alarm interface), but a tab
 * opened by ALARM_START_TIGER (`?live=<config>`) should show only that turbine —
 * matching the desktop, where `online_display <config>` brings up one turbine.
 *
 * Returns only the top-level node whose id matches `config` (the top-level node
 * id is the turbine's `m_config_name`); exact match first, then case-insensitive.
 * If `config` is null/empty (the plain alarm interface) or matches nothing, the
 * full tree is returned unchanged.
 */
export function scopeTreeToConfig(nodes: TreeNode[], config: string | null): TreeNode[] {
  if (!config) return nodes;
  const exact = nodes.filter((n) => n.id === config);
  if (exact.length > 0) return exact;
  const ci = nodes.filter((n) => n.id.toLowerCase() === config.toLowerCase());
  return ci.length > 0 ? ci : nodes;
}

/**
 * Whether the views navigation tree should open fully expanded.
 *
 * The live/replay interface (`-live` desktop / `?live=` web tab) always opens
 * expanded so the scoped turbine's views are immediately visible — matching the
 * C++ `online_display <config>`, which reads the *turbine's* Mviews.ini (mostly
 * no `automatic_views_expansion` key, so the C++ default of 1/expanded applies).
 * The plain alarm interface honours `automatic_views_expansion` from the alarm
 * site's Mviews.ini (often set to 0 to keep the whole-site tree collapsed).
 */
export function autoExpandViewsTree(liveInterface: boolean, configExpand: boolean): boolean {
  return liveInterface || configExpand;
}
